import { classes } from "lib/actions/util";
import { UrlObject } from "url";
import { ButtonProps } from "react-html-props";
import React from "react";
import Link from "next/link";

export default function SidePanelActionButton({
  ref,
  tip,
  isActive,
  href,
  className,
  children,
  ...rest
}: ButtonProps & {
  tip: string;
  isActive?: boolean;
  href?: UrlObject;
}) {
  let button = (
    <button
      ref={ref}
      type="button"
      className={classes(
        "box-content h-6 w-6 px-[3px]",
        "hover:text-icon-hover",
        "disabled:cursor-not-allowed disabled:opacity-50",
        isActive ? "text-icon-active" : "text-icon-normal",
        className,
      )}
      title={tip}
      {...rest}
    >
      {children}
    </button>
  );

  if (href)
    button = (
      <Link href={href} className="flex items-center">
        {button}
      </Link>
    );

  return <>{button}</>;
}
